<template>
    <div class="container-center invite-mng-info" v-loading="dataLoading">
        <div class="inviteInfo solid">
            <p class="title">{{baseData.fname}}</p>
            <p>发布时间：{{baseData.createDate}}</p>
        </div>
        <el-tabs v-model="activeBidNum" type="border-card" @tab-click="" class="tabs-margin canStrategy">
            <el-tab-pane v-for="one in baseData.tabInfoList || []" :label="'标段'+one.bidnum" :name="one.bidnum.toString()">
                <bid-num-box
                    v-if="activeBidNum == one.bidnum"
                    :bid-step="bidStep"
                    :is-new-flag="isNewFlag"
                    :lable-name="priceName"
                    :price-type="tempPriceType"
                    :price-unit="baseData.infoPriceUnit"
                    :end-date="baseData.fprtenderdate"
                    :bid-info="one" @open="handleDialogOpen" @nochange="setNochange"
                    :info-price="baseData.noTaxInfoPrice"
                    :quantities="baseData.quantities"
                    :quantities-unit="baseData.quantitiesUnit"
                    :price-desc="baseData.priceDesc"
                    @callback="getIndependentBidInfo()"></bid-num-box>
            </el-tab-pane>

        </el-tabs>

        <el-dialog title="变更申请" :visible.sync="changeRequestDialog" center width="700px" @close="handleDialogClose"
                   :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form class="invite-form" label-width="140px" ref="changeRequestForm" :model="changeRequestForm"
                     :rules="changeRequestFormRules">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="变更报价：" prop="noTax" v-if="(['1', '5'].indexOf(tempPriceType) > -1) && isNewFlag">
                            <el-input size="medium" v-model.number="changeRequestForm.noTax" clearable>
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>

                        <el-form-item label="变更报价：" prop="noTax" v-if="(['1', '5'].indexOf(tempPriceType) > -1) && !isNewFlag">
                            <el-input size="medium" v-model.number="changeRequestForm.totalPrice" clearable>
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>

                        <el-form-item label="变更报价：" prop="priceUpdate" v-if="['2', '4'].indexOf(tempPriceType) > -1">
                            <el-radio-group v-model="changeRequestForm.floatFlag">
                                <el-radio label="1">上浮</el-radio>
                                <el-radio label="0">下浮</el-radio>
                            </el-radio-group>
                            <el-input class="price-update-input" size="medium" v-model.number="changeRequestForm.priceFloatRate" clearable>
                                <template slot="append">%</template>
                            </el-input>
                        </el-form-item>

                        <el-form-item label="变更报价：" prop="priceUpdate" v-if="tempPriceType == '3'">
                            <el-radio-group v-model="changeRequestForm.floatFlag">
                                <el-radio label="1">上浮</el-radio>
                                <el-radio label="0">下浮</el-radio>
                            </el-radio-group>
                            <el-input class="price-update-input" size="medium" v-model.number="changeRequestForm.floagMoney" clearable>
                                <template slot="append">{{baseData.infoPriceUnit}}</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="变更说明：" prop="changeRemark">
                            <el-input v-model="changeRequestForm.changeRemark" type="textarea" :maxlength="500" :autosize="{minRows: 3}" placeholder="请输入变更说明(最多500个字符)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="附件：">
                            <el-upload
                                ref="fileUpload"
                                :before-upload="beforeFileUpload"
                                :on-remove="handleFileRemove"
                                :action="uploadApi"
                                :on-success="handleFileSuccess"
                                :on-error="handleUploadError"
                                multiple
                                :limit="20"
                                :file-list="changeRequestForm.baseFileList">
                                <el-button size="small" type="primary">上传</el-button>
                                <div slot="tip" class="el-upload__tip" style="line-height: initial;">
                                    上传附件大小请不要超过100M。<br>
                                    <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- 只有，2.总价+浮动比率 3.总价+浮动金额 4.浮动比率+付款比例 需要显示-->
                <span class="aciton-tip-info" v-if="'234'.indexOf(tempPriceType) > -1">
                    *请谨慎调增，除招标人同意，不允许上浮
                </span>
            </el-form>

            <span slot="footer" class="dialog-footer">
            <el-button type="primary" size="small" @click="saveChangeRequest"
                       :loading="changeRequestLoading">提 交</el-button>
            <el-button type="default" size="small" @click="handleDialogClose"
                       :disabled="changeRequestLoading">取 消</el-button>
        </span>

        </el-dialog>
    </div>
</template>

<script>
    import BidNumBox from './components/BidNumBox'
    import banner from '@/assets/imgs/banner_inviteMng.png'
    import util from '@/util'

    export default {
        name: 'IndependentBidInfo',
        components: {
            BidNumBox
        },
        data() {
            return {
                uploadApi: `${util.baseUrl}rest/file/upload`,
                downloadApi: `${util.baseUrl}rest/file/down`,
                fid: decodeURIComponent(this.$route.params.fid),
                supplierId: this.$root.stockId,
                activeBidNum: '1',
                bidStep: 1,
                changeRequestDialog: false,
                changeRequestForm: {
                    supplierId: this.$root.stockId,
                    returnId: '',
                    inviteProjectId: '',
                    nviteProjectEntryId: '',
                    noTax: '',
                    totalPrice: '',
                    payRate: '',
                    changeRemark: '',
                    baseFileList: [],
                    floagMoney: '',
                    priceFloatRate: '',
                    floatFlag: ''
                },
                changeRequestFormRules: {
                    changeRemark: [
                        {required: true, message: '必填'}
                    ]
                },
                changeRequestLoading: false,
                dataLoading: false,
                baseData: {},
                isNewFlag: false,
                priceName: '除税价格',
                tempPriceType: '',
            }
        },
        beforeRouteLeave(to,from,next){
            if(from.name == 'IndependentBidInfo') this.closeWebSocket();
            next();
        },
        mounted() {
            this.getIndependentBidInfo(()=>{
                this.$root.navs = [{name: '招标管理', path: '/inviteMngList'}];
                this.$root.navs.push({name: this.baseData.fname, path: ''});
                this.$root.headImage.src = banner;
                this.$root.activeIndex = 'invite';
                this.$root.isPublic = false;
                if(this.baseData.nowState == '3') this.initWebSocket();

                // 初始化对应的tab
                this.activeBidNum = this.baseData.tabInfoList[0].bidnum.toString()
            });
        },
        methods: {
            initWebSocket(){
                if ("WebSocket" in window) {
                    this.closeWebSocket();
                    let websocketUrl;
                    websocketUrl = util.baseUrl.replace(/https/,'ws') + 'rest/websocket/priceHandler?clientId=' + this.$root.stockId;
                    websocketUrl = util.baseUrl.replace(/http/,'ws') + 'rest/websocket/priceHandler?clientId=' + this.$root.stockId;
                    this.websocketModel = new WebSocket(websocketUrl);
                    this.websocketModel.onopen = function(event){
                        if(event.isTrusted) console.log("连接已建立..");
                    }.bind(this);
                    this.websocketModel.onmessage = function(event){
                        if(event.data == 'change'){
                            console.log('websocket消息：',event);
                            this.getIndependentBidInfo();
                        }
                    }.bind(this);
                    this.websocketModel.onclose = function(){
                        console.log("连接已关闭..");
                    }.bind(this);
                    this.websocketModel.onerror = function(){
                        console.log("websocket发生了错误..");
                    }.bind(this);
                } else {
                    alert("该浏览器不支持websocket!");
                }
            },
            closeWebSocket(){
                if(this.websocketModel) this.websocketModel.close();
            },
            getIndependentBidInfo(fn) {
                this.dataLoading = true;
                this.baseData.tabInfoList = [];
                this.$http.get('rest/api/independentPrice/inquiry/info?supplierId='+ encodeURIComponent(this.supplierId) +'&projectId='+this.fid).then((res) => {
                    this.dataLoading = false;
                    if (res.data.result) {
                        this.baseData = res.data.value || {};
                        this.isNewFlag = this.baseData.isNew == '1'
                        this.tempPriceType = this.baseData.priceType

                        // 对于不同类型的竞价要添加不同的验证规则
                        if (['1', '5'].indexOf(this.tempPriceType) > -1) {
                            // 1：总价  5：付款比例+总价 新项目 除税价  老项目 含税价 必填
                            if (this.isNewFlag) {
                                this.priceName = '除税价'
                                this.changeRequestFormRules.noTax = [
                                    {required: true, message: '必填'},
                                    {type: 'number', message: '数字'}
                                ]
                            } else {
                                this.priceName = '含税价'
                                this.changeRequestFormRules.totalPrice = [
                                    {required: true, message: '必填'},
                                    {type: 'number', message: '数字'}
                                ]
                            }
                        } else if (['2', '3','4'].indexOf(this.tempPriceType) > -1) {
                            // 2：总价+浮动比率 4：付款比例+浮动比率  需要浮动标记 浮动比率 必填 且浮动比率大于
                            this.changeRequestFormRules.priceUpdate = [
                                { validator: this.checkInquery, trigger: 'blur' }
                            ]
                        }
                        
                        this.bidStep = (this.baseData.nowState == '3' || this.baseData.nowState == '4') ? 2 : 1; // nowState: 2-询标 3,4-竞价

                        !!fn && fn();
                    }
                }).catch(()=>{
                    this.dataLoading = false;
                })
            },
            beforeFileUpload(file) {
                if (file.size / 1024 / 1024 > 100) {
                    this.$alert('上传附件大小请不要超过100M', '文件过大！', {type: 'error'});
                    return false
                }

                if (!util.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'});
                    return false
                }
                return true
            },
            handleFileSuccess: function (response, file, fileList) {
                this.changeRequestForm.baseFileList = this.getBaseFiles(fileList);
            },
            handleFileRemove: function (file) {
                this.changeRequestForm.baseFileList = this.changeRequestForm.baseFileList.filter(function (f) {
                    return f.uid !== file.uid
                })
            },
            handleUploadError() {
                this.$message({message: '上传出错，请稍后再试。', type: 'error'})
            },
            getBaseFiles(fileList = []) {
                let fs = [];
                fileList.forEach(function (item) {
                    if (item.response) {
                        let f = item.response.basefiles[0];
                        item.bizTableName = f.biztablename;
                        item.bizTablePkName = f.biztablepkname;
                        item.bizTablePkValue = f.biztablepkvalue;
                        item.fid = f.fid;
                        item.fileCatagoryId = f.filecatagoryid;
                        item.fileDesc = f.filedesc;
                        item.fileOldName = f.fileoldname;
                        item.name = f.fileoldname;
                        item.fileName = f.filename;
                        item.filePath = f.filepath;
                        item.fileSize = f.filesize;
                        item.fileType = f.filetype;
                        item.sort = f.sort;
                    }
                    fs.push(item)
                });
                return fs;
            },
            saveChangeRequest() {
                this.checkDateValid(()=>{
                    if (this.changeRequestLoading) return;
                    this.$refs['changeRequestForm'].validate(valid => {
                        if(valid){
                            if(this.changeRequestLoading) return;
                            this.$confirm('机会只有一次，确定提交变更申请吗？', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                if(this.changeRequestLoading) return;
                                this.changeRequestLoading = true;

                                if (this.tempPriceType == '2') {
                                    // '除税信息价*工程量*（1+上浮比例）'
                                    if (this.changeRequestForm.floatFlag == '0') {
                                        // 下浮
                                        let tempPrice = ((Number(this.baseData.noTaxInfoPrice) * 100) * (Number(this.baseData.quantities) * 100) * (10000 - (Number(this.changeRequestForm.priceFloatRate) * 100))) / 100000000
                                        this.changeRequestForm.noTax = Number(parseFloat(tempPrice).toFixed(2))
                                    } else if (this.changeRequestForm.floatFlag == '1') {
                                        // 上浮
                                        let tempPrice = ((Number(this.baseData.noTaxInfoPrice) * 100) * (Number(this.baseData.quantities) * 100) * (10000 + (Number(this.changeRequestForm.priceFloatRate) * 100))) / 100000000
                                        this.changeRequestForm.noTax = Number(parseFloat(tempPrice).toFixed(2))
                                    }
                                } else if (this.tempPriceType == '3') {
                                    if (this.changeRequestForm.floatFlag == '0') {
                                        // 下浮
                                        let tempPrice = (((Number(this.baseData.noTaxInfoPrice) * 100) * (Number(this.baseData.quantities) * 100)) - (Number(this.changeRequestForm.floagMoney) * 10000)) / 10000
                                        this.changeRequestForm.noTax = Number(parseFloat(tempPrice).toFixed(2))
                                    } else if (this.changeRequestForm.floatFlag == '1') {
                                        // 上浮
                                        let tempPrice = (((Number(this.baseData.noTaxInfoPrice) * 100) * (Number(this.baseData.quantities) * 100)) + (Number(this.changeRequestForm.floagMoney) * 10000)) / 10000
                                        this.changeRequestForm.noTax = Number(parseFloat(tempPrice).toFixed(2))
                                    }
                                }

                                this.$http.post('rest/api/independentPrice/inquiry/changeApply', this.changeRequestForm).then((res) => {
                                    this.changeRequestLoading = false;
                                    if (res.data.result) {
                                        this.$message.success('提交成功');
                                        this.handleDialogClose();
                                        this.getIndependentBidInfo();
                                    }else {
                                        this.$message.error('提交失败');
                                    }
                                }).catch(()=>{
                                    this.changeRequestLoading = false;
                                    this.$message.error('提交失败');
                                })
                            }).catch(() => {

                            })
                        }
                    })
                })
            },
            handleDialogClose() {
                if (this.changeRequestLoading) return;
                this.$refs['changeRequestForm'].resetFields();
                this.$refs['changeRequestForm'].clearValidate();
                this.$refs['fileUpload'].clearFiles();
                this.changeRequestForm = {
                    supplierId: this.$root.stockId,
                    payRate: '',
                    returnId: '',
                    inviteProjectId: '',
                    nviteProjectEntryId: '',
                    noTax: '',
                    changeRemark: '',
                    baseFileList: []
                };
                this.changeRequestDialog = false;
            },
            checkDateValid(fn,row){
                this.$http.get('rest/api/invite/project/getCurrentTimeLong').then((res)=>{
                    if(res.data.result){
                        let endDateTime = new Date(this.baseData.fprtenderdate).getTime();
                        let currentDateTime = res.data.value;
                        if(currentDateTime <= endDateTime){
                            !!fn && fn(row);
                        }else {
                            this.$alert('已到截止时间，不能执行此操作！',{type:'warning'})
                        }
                    }
                })
            },
            handleDialogOpen(row = {}) {
                this.checkDateValid(val =>{
                    this.changeRequestForm = {
                        supplierId: this.$root.stockId,
                        returnId: val.id,
                        inviteProjectId: val.inviteProjectId,
                        nviteProjectEntryId: val.nviteProjectEntryId,
                        noTax: val.noTax,
                        totalPrice: val.totalPrice,
                        payRate: val.payRate,
                        changeRemark: '',
                        baseFileList: [],
                        priceFloatRate: val.priceFloatRate,
                        floatFlag: val.floatFlag,
                        floagMoney: val.floagMoney
                    };
                    this.changeRequestDialog = true;
                },row)
            },
            checkInquery (rule, value, callback) {
                if (!this.changeRequestForm.floatFlag) {
                    return callback(new Error('浮动类型必选'));
                } else {
                    // 浮动类型填写之后
                    if (this.tempPriceType == '3') {
                        // 3：总价+浮动金额 浮动金额必填
                        if (!this.changeRequestForm.floagMoney) {
                            return callback(new Error('浮动金额必须填写'))
                        } else {
                            // 如果填写了金额，判断是否是否是数字
                            if (!Number(this.changeRequestForm.floagMoney)) {
                                return callback(new Error('浮动金额必须是数字'));
                            } else if (this.changeRequestForm.floagMoney <= 0) {
                                return callback(new Error('浮动金额必须大于0'))
                            } else {
                                callback()
                            }
                        }
                    } else {
                        // 如果是 2 总价+付款比例 或者 4 付款比例+浮动比率 浮动比率
                        if (!this.changeRequestForm.priceFloatRate) {
                            return callback(new Error('浮动比率必须填写'))
                        } else {
                            // 如果填写了，判断是否是否是数字
                            if (!Number(this.changeRequestForm.priceFloatRate)) {
                                return callback(new Error('浮动比率必须是数字'));
                            } else if (this.changeRequestForm.priceFloatRate <= 0 || this.changeRequestForm.priceFloatRate >= 100) {
                                return callback(new Error('浮动比率必须大于0小于100'))
                            } else {
                                callback()
                            }
                        }
                    }
                }
            },
            setNochange (returnId) {
                this.checkDateValid(val =>{
                    this.$confirm('确定要维持原价吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.submitLoading = true;
                        this.$http.get('rest/api/independentPrice/inquiry/noChange?returnId=' + val ).then((res) => {
                            this.submitLoading = false;
                            if (res.data.result) {
                                this.$message.success('提交成功');
                                this.getIndependentBidInfo();
                            }else {
                                this.$message.error('提交失败');
                            }
                        }).catch(()=>{
                            this.submitLoading = false;
                            this.$message.error('提交失败');
                        })
                    }).catch(() => {
                    })
                }, returnId)

            }
        }

    }
</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';

    a {
        color: var(--cMain);
    }

    ul {
        padding: 0;
        margin: 0;
    }

    ul li {
        list-style: none;
    }

    ul.invite-mng-list li {
        padding: 14px 12px;
        font-size: 14px;
        line-height: 28px;
    }

    ul.invite-mng-list li + li {
        border-top: 1px dashed #E5E6E5;
    }

    /*ul.invite-mng-list li:nth-child(odd) {background:#f8f8f8;}*/
    ul.invite-mng-list li a {
        color: var(--cTxt1);
        text-decoration: none;
    }

    ul.invite-mng-list li a:hover {
        color: var(--cMain);
    }

    .inviteInfo {
        font-size: 14px;
    }

    .inviteInfo.solid {
        height: 100px;
        border-bottom: 1px solid #E6E7E6;
        padding-top: 50px;
        position: relative;
    }

    .inviteInfo.solid > p {
        margin: 0 0 24px 0;
        color: #000;
        font-size: 14px;
        text-align: center;
    }

    .inviteInfo.solid > p.title {
        font-size: 18px;
        font-weight: bold;
    }

    .inviteInfo.solid > p.title.strategy::after {
        content: '战略';
        display: inline-block;
        width: 40px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        font-size: 12px;
        font-weight: normal;
        color: #fff;
        background: var(--cMint);
        border-radius: 2px;
        vertical-align: bottom;
        margin-left: 10px;
    }

    .inviteInfo.dashed {
        padding-bottom: 10px;
        border-bottom: 1px dashed #E6E7E6;
    }

    .inviteInfo.dashed.segment {
        margin-bottom: 20px;
    }

    .inviteInfo h5 {
        color: #252525;
        font-size: 15px;
        margin: 16px 0;
    }

    .inviteInfo h5::before {
        content: '';
        display: inline-block;
        width: 5px;
        height: 5px;
        background: var(--cMain);
        vertical-align: middle;
        margin: 0 10px;
    }

    .inviteInfo .el-row {
        margin-bottom: 12px;
        word-break: break-all;
    }

    .inviteInfo .el-col-3,
    .inviteInfo .el-col-6 {
        color: #5f5f5f;
        text-align: right;
    }


    /* step */


    .invite-btm-step {
        margin: 0;
        padding: 0;
        font-size: 14px;
    }

    .invite-btm-step a {
        color: var(--cMain);
    }

    .invite-btm-step li {
        width: 100%;
        list-style: none;
        float: left;
        height: 64px;
    }

    .invite-btm-step li:nth-child(even) {
        background: #F8F8F8;
    }

    .invite-btm-step div {
        float: left;
        height: 64px;
    }

    .invite-btm-step div span {
        margin-top: 20px;
    }

    .invite-btm-step div:nth-child(1) {
        width: 100px;
        padding: 0 40px;
        padding-top: 20px;
    }

    .invite-btm-step div:nth-child(2) {
        width: 100px;
        padding: 0 40px;
        padding-left: 20px;
    }

    .invite-btm-step div:nth-child(2)::before {
        content: '';
        position: absolute;
        display: block;
        width: 2px;
        height: 64px;
        background: #efefef;
        margin-left: -20px;
        z-index: 0;
    }

    .invite-btm-step div:nth-child(2) span {
        display: inline-block;
        color: #fff;
        background: #efefef;
        width: 60px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 10px;
    }

    .invite-btm-step div:nth-child(2) span.info {
        background: #8EB4E5;
    }

    .invite-btm-step div:nth-child(2) span.success {
        background: #9DC34C;
    }

    .invite-btm-step div:nth-child(3) {
        padding-top: 18px;
    }

    .invite-unit {
        display: inline-block;
        width: 49%;
        margin-top: 16px;
    }

    .btn-theme {
        width: 120px;
        margin: 50px 0;
    }

    .box-bordered {
        border: 1px solid #DCDFE6;
        padding: 10px 20px;
        margin-bottom: 20px;
    }

    .select-info {
        padding-left: 20px;
        font-size: 14px;
        color: var(--cTxt3);
        padding-bottom: 10px;
        border-bottom: 1px solid #efefef;
    }

    .select-info .el-col.el-col-2 {
        text-align: right;
    }

    .select-info .el-col.el-col-5 {
        color: var(--cTxt1);
    }

    .select-info b {
        color: var(--cTxt1);
    }

    .tabs-margin {
        margin: 20px 0 40px 0;
    }

    .reconTemplate {
        float: right;
        color: var(--cMain);
    }

    .review-back {
        position: fixed;
        bottom: 60px;
        left: 50%;
        margin-left: -100px;
        z-index: 9;
        box-shadow: 0 6px 30px rgba(242, 134, 25, .5);
        width: 200px;
        text-shadow: 0 2px 2px rgba(0, 0, 0, .1);
    }

    .btn-nego {
        position: relative;
    }

    .btn-nego span {
        position: absolute;
        display: block;
        background: #F45454;
        color: #fff;
        border-radius: 12px;
        margin-left: 52px;
        margin-top: -6px;
        padding: 2px 6px;
        font-size: 12px;
    }

    .btn-managers {
        position: absolute;
        margin-left: 1104px;
    }

    .btn-managers {
        position: absolute;
        margin-left: 1104px !important;
    }


    .price-box {
        border-top: 1px dashed #dcdddc;
        padding: 20px 0;
        text-align: center;
    }

    .price-box .price-left,
    .price-box .price-right {
        display: inline-block;
        width: 45%;
        padding: 20px 0;
        text-align: left;
        box-shadow: none;
        vertical-align: top;
        min-height: 300px;
    }

    .price-box .price-right {
        margin-left: 2%;
    }


    .price-box .price-left ul li + li {
        margin-top: 50px;
    }

    .price-box .price-left ul li + li:before {
        position: absolute;
        display: inline-block;
        content: '';
        width: 4px;
        height: 50px;
        background: #DFE3E7;
        margin-left: 7px;
        margin-top: -51px;
    }

    .price-box .price-left ul li label {
        padding-left: 30px;
        font-weight: bold;
    }

    .price-box .price-left ul li label:before {
        position: absolute;
        display: inline-block;
        content: '';
        width: 12px;
        height: 12px;
        border-radius: 12px;
        margin-left: -30px;
        margin-top: 3px;
        background: var(--cMain);
        border: 3px solid #FFECC5;
    }

    .price-box .price-left ul li span {
        color: var(--cMain);
        font-weight: bold;
        font-size: 18px;
    }

    .price-box .price-left ul li i {
        display: inline-block;
        padding: 2px 8px;
        border-radius: 4px;
        font-style: normal;
        font-size: 12px;
        color: #fff;
        background: var(--cMint);
    }

    .price-box .price-left ul li i.fail {
        background: var(--cFail);
    }

    .price-timer {
        text-align: center;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .price-timer span {
        color: var(--cMain);
    }

    .price-box .price-right .price-timer {
        font-size: 20px;
    }

    .price-right-tip {
        height: 240px;
        background: url('') no-repeat center;
    }

    .price-right-tip.success {
        background-image: url(data:image/png;base64,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);
    }

    .price-right-tip.fail {
        background-image: url(data:image/png;base64,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);
    }

    .price-right-tip.pass {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        color: #F28718;
        line-height: 100px;
    }

    .price-right-tip.pass::before {
        content: '下一轮未开始，等待中..';
    }

    .price-right-tip.result {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        color: #F28718;
        line-height: 100px;
    }

    .price-caps {
        color: var(--cMain);
        text-align: center;
        font-size: 26px;
        font-weight: bold;
    }

    .el-col {
        padding-bottom: 6px;
    }

    .el-alert.el-alert--error {
        margin-top: 12px;
    }

    /* 返回按钮动画 */
    .bounce-enter-active {
        animation: bounce-in .32s;
    }

    .bounce-leave-active {
        animation: bounce-in .32s reverse;
    }

    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.2);
        }
        100% {
            transform: scale(1);
        }
    }

    .el-button-grey {
        background: #ccc;
        border: 1px solid #ccc;
    }

    .el-button-grey:hover {
        background: #ccc;
        border: 1px solid #ccc;
    }

    .option-btn-group {
        position: absolute;
        right: 0;
    }

    .tech-fail-div {
        border: solid 1px #E4E7ED;
        margin-top: 10px;
    }

    .tech-fail-div h4 {
        margin-block-start: 10px;
        margin-block-end: 5px;
        margin-inline-start: 10px;
        font-size: 14px;
    }

    .tech-fail-div div {
        margin: 10px 10px;
        font-size: 14px;
    }
    .price-update-input {
        width: 150px;
        margin-left: 20px;
    }

    .aciton-tip-info {
        margin-left: 70px;
        color: #fa0303;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/invite/IndependentBidInfo.vue